import { FormikSelectOption, SortingDropdown } from 'components';
import { useQuerySorting } from 'hooks';

type Props = {
  sortingFields: FormikSelectOption[];
};

export const QuerySorting: React.FC<Props> = ({ sortingFields }) => {
  const { sorting, resetSorting, setSorting } = useQuerySorting();

  return (
    <SortingDropdown
      sorting={sorting}
      sortingFields={sortingFields}
      initialValues={sorting}
      onReset={resetSorting}
      onSubmit={setSorting}
    />
  );
};
